var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.b(),_vm.classString]},[_c('span',{class:_vm.b('text')},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }